const state = {
  assetsNumber: 9,
};

const getters = {
  getAssetsNumber: state => state.assetsNumber,
};

const actions = {
  showMoreAssets({ commit }) {
    commit('loadMore');
  },
};

const mutations = {
  loadMore: state => (state.assetsNumber += 9),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
